import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const TogetherListenIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-togetherListen"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M34 7a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M32 12a2 2 0 0 1 1.995 1.85L34 14h-1a1 1 0 0 0-1.993-.117L31 14h-1a2 2 0 0 1 2-2m4 0a2 2 0 0 1 1.995 1.85L38 14h-1a1 1 0 0 0-1.993-.117L35 14h-1a2 2 0 0 1 2-2m-3.25 5.25a1 1 0 0 0 1.993.117l.007-.117h1a2 2 0 0 1-3.995.15l-.005-.15zM34 21a8 8 0 0 1 7.996 7.75L42 29h-2a6 6 0 0 0-11.996-.225L28 29h-2a8 8 0 0 1 8-8M20 7a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M18 12a2 2 0 0 1 1.995 1.85L20 14h-1a1 1 0 0 0-1.993-.117L17 14h-1a2 2 0 0 1 2-2m4 0a2 2 0 0 1 1.995 1.85L24 14h-1a1 1 0 0 0-1.993-.117L21 14h-1a2 2 0 0 1 2-2m-2.5 3v1a1 1 0 0 0-.117 1.993L19.5 18v1a2 2 0 0 1-.15-3.995zm.5 6a8 8 0 0 1 7.996 7.75L28 29h-2a6 6 0 0 0-11.996-.225L14 29h-2a8 8 0 0 1 8-8M48 7a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M46 12a2 2 0 0 1 1.995 1.85L48 14h-1a1 1 0 0 0-1.993-.117L45 14h-1a2 2 0 0 1 2-2m4 0a2 2 0 0 1 1.995 1.85L52 14h-1a1 1 0 0 0-1.993-.117L49 14h-1a2 2 0 0 1 2-2m-2 3a2 2 0 0 1 .15 3.995L48 19v-1a1 1 0 0 0 .117-1.993L48 16zm0 6a8 8 0 0 1 7.996 7.75L56 29h-2a6 6 0 0 0-11.996-.225L42 29h-2a8 8 0 0 1 8-8"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M5.707 21.293C3.524 19.458 2 16.91 2 14s1.524-5.457 3.707-7.293c.986-.83-.435-2.238-1.414-1.414C1.72 7.457 0 10.593 0 14s1.72 6.543 4.293 8.707c.98.824 2.401-.584 1.414-1.414"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M7.707 17.293c-.585-.494-.98-.947-1.319-1.62A3.85 3.85 0 0 1 6 14a5 5 0 0 1 .02-.456l.017-.103q.025-.128.052-.255c.08-.34.168-.592.274-.81.341-.696.745-1.163 1.344-1.67.413-.347.36-1.054 0-1.413-.409-.41-1-.35-1.414 0C4.911 10.46 4 12.17 4 14s.911 3.54 2.293 4.707c.412.348 1.01.405 1.414 0 .357-.357.415-1.064 0-1.414M63.708 22.707C66.28 20.543 68 17.407 68 14s-1.72-6.543-4.293-8.707c-.98-.824-2.401.584-1.414 1.414C64.476 8.542 66 11.089 66 14c0 2.91-1.525 5.457-3.707 7.293-.986.829.435 2.238 1.414 1.414"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M61.707 18.707C63.09 17.54 64 15.83 64 14s-.91-3.54-2.293-4.707c-.412-.348-1.01-.405-1.414 0-.358.357-.415 1.064 0 1.414.585.494.98.947 1.32 1.62.248.496.387 1.107.387 1.673a6 6 0 0 1-.02.456q-.008.053-.017.103-.024.128-.053.255a3.7 3.7 0 0 1-.274.81c-.34.696-.744 1.163-1.343 1.67-.413.347-.359 1.054 0 1.413.41.41 1 .35 1.414 0"
        />
      </g>
    </Icon>
  )
}
